import React, { useState, forwardRef } from "react";
import {
  Col,
  Empty,
  Popover,
  Row,
  Space,
  Typography,
  Tooltip,
  Button,
  message,
  Drawer,
} from "antd";
import { StarOutlined, FireOutlined } from "@ant-design/icons";
import Sc from "@/assets/images/sc.svg";
import Qxsc from "@/assets/images/qxsc.svg";
import Rd from "@/assets/images/rd.svg";
import API from "@/api";
import axios from "axios";
import moment from "moment";
import DrawerDetail from "./drawerDetail";

function CardDetail(props, ref) {
  const { data, onClick, style, mobile = false } = props;
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});

  if (ref) {
    ref.current = {
      closeModel: () => {
        setOpen(false);
      },
    };
  }

  const formatDialogCount = (count) => {
    const num = Number(count);

    // 处理非数字/负数/NaN情况，默认显示0
    if (isNaN(num) || num <= 0) {
      return "0";
    }

    // 转为整数（避免小数干扰，比如12.9→12、"1492.5"→1492）
    const intNum = Math.floor(num);
    // 1位数（0-9）：直接显示
    if (num < 10) {
      return String(num);
    }

    // 2位数（10-99）：十位数字 + "0+"
    if (num < 100) {
      const tens = Math.floor(num / 10); // 提取十位数字
      return `${tens}0+`;
    }

    // 3位数（100-999）：百位数字 + "00+"
    if (num < 1000) {
      const hundreds = Math.floor(num / 100); // 提取百位数字
      return `${hundreds}00+`;
    }

    // 4位数（1000-9999）：千位数字 + "000+"
    if (num < 10000) {
      const thousands = Math.floor(num / 1000); // 提取千位数字
      return `${thousands}000+`;
    }

    // ≥5位数：x.y万+（y为0时不显示）
    const wan = Math.floor(num / 10000); // 提取万位及以上的整数部分
    const qian = Math.floor((num % 10000) / 1000); // 提取千位数字（0-9）

    if (qian === 0) {
      return `${wan}万+`;
    } else {
      return `${wan}.${qian}万+`;
    }
  };
  const csData = [
  {
    "children": [],
    "createdAt": "2025-12-26 12:04:35",
    "createdBy": "杨洋(L2#####88)",
    "id": "gns://57421F8DF7284EDDAF784D6F4991A33F",
    "modifiedAt": "2026-04-03 07:17:24",
    "modifiedBy": "杨洋(L2#####88)",
    "name": "杨洋(L2#####88)",
    "rev": "E560582FB5D54CBB9CE82797997D59F2",
    "type": "user_doc_lib",
    "typeName": "我的文档库"
  },
  {
    "children": [],
    "createdAt": "2026-03-31 06:42:31",
    "createdBy": "admin",
    "id": "gns://76B707EB1B79498887D5460B3D45AE49",
    "modifiedAt": "2026-03-31 06:42:31",
    "modifiedBy": "admin",
    "name": "知识库-信息技术中心",
    "rev": "8c6334a5-fe0e-492a-8245-edfb42ecd94c",
    "type": "department_doc_lib",
    "typeName": "部门文档库"
  }
]


  return (
    <>
      <Row gutter={[32, 32]} className="zdCardDetail" style={style}>
        {data?.length ? (
          data?.map((item, index) => {
            return mobile ? (
              <div
                className="m-znt-space"
                key={index}
                style={{ cursor: "pointer" }}
              >
                <div
                  className="listItem"
                  key={index}
                  onClick={() => {
                    setOpen(true);
                    setSelectedRow(item);
                  }}
                >
                  <div className="iconContent">
                    <div className="icon">
                      <img src={item?.icon} />
                    </div>
                    <div className="wrapContent" style={{
                        width: "calc(100% - 75px)",
                      }}>
                        <div className="titleAndContent">
                        <div
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            padding: "12px 0",
                          }}
                        >
                          <Tooltip title={item.label}>{item.label}</Tooltip>
                        </div>
                        <div
                          style={{
                            color: "#00000072",
                          }}
                        >
                          所有者：{item.user}
                        </div>
                        <div
                          style={{
                            color: "#00000072",
                            padding: "4px 0",
                          }}
                        >
                          发布时间：{moment(item.sj).format("YYYY-MM-DD")}
                        </div>
                        <div
                          style={{
                            color: "#00000072",
                            textAlign: "right",
                          }}
                        >
                          {item.source}
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            ) : (
              <Col
                className="znt-col"
                xs={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 8 }}
                key={index}
              >
                <div className="listItem" key={index}>
                  <div
                    className="iconContent"
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      // onClick?.(item);
                      setOpen(true);
                      setSelectedRow(item);
                    }}
                  >
                    <div className="icon">
                      <img src={item?.icon} />
                    </div>
                    <div
                      className="wrapContent"
                      style={{
                        width: "calc(100% - 75px)",
                      }}
                    >
                      <div className="titleAndContent">
                        <div
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            padding: "12px 0",
                          }}
                        >
                          <Tooltip title={item.label}>{item.label}</Tooltip>
                        </div>
                        <div
                          style={{
                            color: "#00000072",
                          }}
                        >
                          所有者：{item.user}
                        </div>
                        <div
                          style={{
                            color: "#00000072",
                            padding: "4px 0",
                          }}
                        >
                          发布时间：{moment(item.sj).format("YYYY-MM-DD")}
                        </div>
                        <div
                          style={{
                            color: "#00000072",
                            textAlign: "right",
                          }}
                        >
                          {item.source}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            );
          })
        ) : (
          <Col span={24}>
            <div style={{ textAlign: "center", paddingTop: "20px" }}>
              <Typography.Text style={{ textAlign: "center" }} type="secondary">
                <Empty style={{ height: 50 }} description={"暂无数据"}></Empty>
              </Typography.Text>
            </div>
          </Col>
        )}
        <div></div>
      </Row>
      <Drawer
        title=""
        open={open}
        onClose={() => {
          setOpen(false);
          setSelectedRow({});
        }}
        width={mobile?"100%" : "65%"}
        footer={
          <>
            <Space>
              <Button
                onClick={() => {
                  setOpen(false);
                  setSelectedRow({});
                }}
              >
                关闭
              </Button>
            </Space>
          </>
        }
      >
        <DrawerDetail selectedRow={selectedRow} onClick={onClick} />
      </Drawer>
    </>
  );
}

export default forwardRef(CardDetail);
